<div class="success-body">
  <div class="transaction-success-container">
    <i class="fa fa-check-circle icon-success"></i>
    <h1 class="trx-exitosa">Transacción Exitosa</h1>
  </div>
  <div class="card-container">
    <p>{{ nombrePaciente }}, el pago ha sido completado con éxito.</p>
    <strong>Detalles del pago:</strong>
    <div class="payment-details">
      <ul class="details-list">
        <li><strong>ID de Pago:</strong> {{ idPago }}</li>
        <li><strong>Número de Orden:</strong> {{ numeroOrden }}</li>
        <li><strong>Tipo de Pago:</strong> {{ tipoPago }}</li>
        <li><strong>Fecha de Creación:</strong> {{ fechaRegistroPago }}</li>
        <li><strong>Curso:</strong> {{ aplicacion }}</li>
        <li><strong>Total Pagado:</strong> {{ totalPagar }}</li>
      </ul>
    </div>
  </div>
  <div class="submit-container">
    <button
      class="btn-custom"
      type="button"
      (click)="redirectToMeds()"
    >
      Volver a MEDS
    </button>
  </div>  
</div>
